// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1XDZf","upload":"Small_upload__29Z7Z","imageWrap":"Small_imageWrap__1eGmZ","removeBtn":"Small_removeBtn__1GI61"};